import English from './en';
import Chinese from './zh';
export default {
  English: English,
  Chinese: Chinese
}